(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c_hero"] && !Shopify.designMode) return;
  try {
    
  class CHeroSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.c-hero__track');
      this.slides = [...this.querySelectorAll('.c-hero__slide')];
      this.wrapper = this.querySelector('.c-hero__track-wrapper');
      this.prevBtn = this.querySelector('.c-hero__arrow--prev');
      this.nextBtn = this.querySelector('.c-hero__arrow--next');
      this.dots = [...this.querySelectorAll('.c-hero__dot')];
      this.status = this.querySelector('.c-hero__status');
      this.current = 0;
      this.total = this.slides.length;
      this.visualIndex = this.total > 1 ? 1 : 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = Number(this.dataset.autoplaySpeed || 5) * 1000;
      this.startX = 0;
      this.deltaX = 0;

      if (this.total > 1) this.createLoopClones();

      this.onPrev = () => this.go(this.current - 1, true);
      this.onNext = () => this.go(this.current + 1, true);
      this.onVisibilityChange = () => document.hidden ? this.stopTimer() : this.startTimer();
      this.onTransitionEnd = (event) => {
        if (event.target !== this.track || event.propertyName !== 'transform') return;

        if (this.visualIndex === 0) {
          this.jumpToLoopSlide(this.total);
        } else if (this.visualIndex === this.total + 1) {
          this.jumpToLoopSlide(1);
        }
      };
      this.onSlideClick = (event) => {
        const slide = event.target.closest('.c-hero__slide');
        if (!slide || slide.classList.contains('is-active')) return;

        const index = Number(slide.dataset.slideIndex);
        if (!Number.isInteger(index)) return;

        event.preventDefault();
        event.stopPropagation();

        if (slide.classList.contains('is-clone')) {
          const renderedIndex = this.renderedSlides.indexOf(slide);
          this.current = index;
          this.visualIndex = renderedIndex;
          this.position(true);
          this.updateState();
          this.stopTimer();
          this.startTimer();
          return;
        }

        this.go(index, true);
      };
      this.onKeydown = (event) => {
        if (event.key === 'ArrowLeft') this.onPrev();
        if (event.key === 'ArrowRight') this.onNext();
      };
      this.onTouchStart = (event) => {
        this.startX = event.touches[0].clientX;
        this.deltaX = 0;
        this.stopTimer();
      };
      this.onTouchMove = (event) => {
        this.deltaX = event.touches[0].clientX - this.startX;
      };
      this.onTouchEnd = () => {
        if (Math.abs(this.deltaX) > 50) {
          this.go(this.current + (this.deltaX < 0 ? 1 : -1), true);
        } else {
          this.startTimer();
        }
      };

      this.prevBtn?.addEventListener('click', this.onPrev);
      this.nextBtn?.addEventListener('click', this.onNext);
      this.track.addEventListener('transitionend', this.onTransitionEnd);
      this.track.addEventListener('click', this.onSlideClick, true);
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.go(Number(dot.dataset.slideTo), true));
      });
      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('mouseenter', () => this.stopTimer());
      this.addEventListener('mouseleave', () => this.startTimer());
      this.addEventListener('focusin', () => this.stopTimer());
      this.addEventListener('focusout', () => this.startTimer());
      this.addEventListener('touchstart', this.onTouchStart, { passive: true });
      this.addEventListener('touchmove', this.onTouchMove, { passive: true });
      this.addEventListener('touchend', this.onTouchEnd);
      document.addEventListener('visibilitychange', this.onVisibilityChange);

      if (window.Shopify?.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.indexOf(event.target);
          if (index >= 0) this.go(index);
          this.stopTimer();
        });
      }

      this.resizeObserver = new ResizeObserver(() => this.position(false));
      this.resizeObserver.observe(this.wrapper);

      this.updateState();
      requestAnimationFrame(() => this.position(false));
      this.startTimer();
    }

    disconnectedCallback() {
      this.stopTimer();
      this.resizeObserver?.disconnect();
      this.prevBtn?.removeEventListener('click', this.onPrev);
      this.nextBtn?.removeEventListener('click', this.onNext);
      this.track?.removeEventListener('transitionend', this.onTransitionEnd);
      this.track?.removeEventListener('click', this.onSlideClick, true);
      this.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('touchstart', this.onTouchStart);
      this.removeEventListener('touchmove', this.onTouchMove);
      this.removeEventListener('touchend', this.onTouchEnd);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }

    createLoopClones() {
      const firstClone = this.createClone(this.slides[0]);
      const lastClone = this.createClone(this.slides[this.total - 1]);
      this.track.prepend(lastClone);
      this.track.append(firstClone);
      this.renderedSlides = [...this.track.querySelectorAll('.c-hero__slide')];
    }

    createClone(slide) {
      const clone = slide.cloneNode(true);
      clone.classList.add('is-clone');
      clone.removeAttribute('data-shopify-editor-block');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
      return clone;
    }

    jumpToLoopSlide(index) {
      this.classList.add('is-loop-jumping');
      this.visualIndex = index;
      this.updateState();
      this.position(false);
      this.getBoundingClientRect();

      requestAnimationFrame(() => {
        this.classList.remove('is-loop-jumping');
      });
    }

    go(index, userInitiated = false) {
      if (this.total < 2) return;

      if (index < 0) {
        this.current = this.total - 1;
        this.visualIndex = 0;
      } else if (index >= this.total) {
        this.current = 0;
        this.visualIndex = this.total + 1;
      } else {
        this.current = index;
        this.visualIndex = index + 1;
      }

      this.position(true);
      this.updateState();

      if (userInitiated) {
        this.stopTimer();
        this.startTimer();
      }
    }

    position(animate = true) {
      const renderedSlides = this.renderedSlides || this.slides;
      const activeSlide = renderedSlides[this.visualIndex];
      if (!activeSlide || !this.wrapper) return;

      this.track.style.transition = animate ? '' : 'none';
      const offset = (this.wrapper.clientWidth - activeSlide.offsetWidth) / 2 - activeSlide.offsetLeft;
      this.track.style.transform = `translate3d(${offset}px, 0, 0)`;

      if (!animate) {
        this.track.getBoundingClientRect();
        this.track.style.transition = '';
      }
    }

    updateState() {
      const renderedSlides = this.renderedSlides || this.slides;
      renderedSlides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === this.visualIndex);
      });

      this.slides.forEach((slide, index) => {
        const inactive = index !== this.current;
        slide.setAttribute('aria-hidden', String(inactive));
      });
      this.dots.forEach((dot, index) => {
        const active = index === this.current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });
      if (this.status && this.total > 1) {
        this.status.textContent = `${this.current + 1}枚目 / ${this.total}枚`;
      }
    }

    startTimer() {
      if (!this.autoplay || this.total < 2 || document.hidden || window.Shopify?.designMode) return;
      this.stopTimer();
      this.timer = window.setInterval(() => this.go(this.current + 1), this.autoplaySpeed);
    }

    stopTimer() {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  if (!customElements.get('c-hero-slider')) {
    customElements.define('c-hero-slider', CHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
